// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.main-container {
  padding: 24px 32px;
  font-family: "Gotham", Arial, sans-serif;
}

.top-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top-container #title {
  font-size: large;
  font-family: "GothamBold", Arial, sans-serif;
}
.top-container .close-btn {
  border: none;
  background: none;
  cursor: pointer;
  color: #707070;
}

.modal-subtitle {
  font-size: 14px;
  color: #707070;
  font-family: "Gotham", Arial, sans-serif;
  margin-bottom: 16px;
}

.creation-type-toggle {
  margin-bottom: 20px;
}
.creation-type-toggle mat-button-toggle-group {
  border-radius: 4px;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 13px;
}
.creation-type-toggle mat-button-toggle-group ::ng-deep .mat-button-toggle-button {
  padding: 0 20px;
  height: 36px;
  line-height: 36px;
}
.creation-type-toggle mat-button-toggle-group ::ng-deep .mat-button-toggle-checked {
  background-color: #0066b2;
  color: #ffffff;
}

.modal-content {
  display: flex;
  flex-direction: column;
  border: none;
}
.modal-content ::ng-deep .mat-form-field-outline {
  color: #e3e3e3;
}

.form-field {
  display: flex;
  flex-direction: column;
}
.form-field .field-label {
  font-size: 13px;
  color: #707070;
  font-family: "Gotham", Arial, sans-serif;
  margin-bottom: 4px;
}
.form-field .field-label.error-label {
  color: #e21836;
}
.form-field .field-label .optional-label {
  font-size: 11px;
  color: #8c8f93;
  font-style: italic;
}
.form-field .full-width {
  width: 100%;
}
.form-field .tag-error ::ng-deep .mat-form-field-outline,
.form-field .tag-error ::ng-deep .mat-form-field-outline-start,
.form-field .tag-error ::ng-deep .mat-form-field-outline-gap,
.form-field .tag-error ::ng-deep .mat-form-field-outline-end,
.form-field .tag-error ::ng-deep .mdc-notched-outline__leading,
.form-field .tag-error ::ng-deep .mdc-notched-outline__notch,
.form-field .tag-error ::ng-deep .mdc-notched-outline__trailing {
  border-color: #e21836;
  color: #e21836;
}

.form-row {
  display: flex;
  gap: 16px;
}
.form-row .half-width {
  flex: 1;
}
.form-row .full-width {
  flex: 1 1 100%;
}

.clone-draft-error {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #e21836;
  font-size: 13px;
  font-family: "Gotham", Arial, sans-serif;
  margin-top: 8px;
}
.clone-draft-error .error-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  vertical-align: middle;
}

.no-releases-message {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #e21836;
  font-size: 13px;
  font-family: "Gotham", Arial, sans-serif;
  padding: 8px 0 4px;
}
.no-releases-message .error-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  vertical-align: middle;
}

.release-hint {
  font-size: 12px;
  color: #8c8f93;
  font-style: italic;
  margin: 2px 0 8px;
}

.inline-label-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-left: 6px;
}

.validation-status {
  display: flex;
  align-items: center;
  min-height: 20px;
  margin-top: -12px;
}
.validation-status .error-text {
  color: #e21836;
  font-size: 12px;
  font-family: "Gotham", Arial, sans-serif;
}
.validation-status .warning-text {
  color: #ff9800;
  font-size: 12px;
  font-family: "Gotham", Arial, sans-serif;
  font-style: italic;
}

.progress-bar-container {
  margin: 8px 0;
}

.valve-type-search-container {
  padding: 8px 8px 4px;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1000;
}
.valve-type-search-container .valve-type-search-input {
  width: 100%;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
}
.valve-type-search-container .valve-type-search-input:focus {
  border-color: #1976d2;
}

::ng-deep .mat-mdc-select-panel:has(.valve-type-search-container) {
  padding-top: 0 !important;
}

.lower-container {
  margin-top: 16px;
  text-align: right;
}
.lower-container .btn-divider {
  width: 12px;
  display: inline-block;
}
.lower-container button {
  display: inline-block;
  min-width: 100px;
  padding: 8px 24px;
  font-size: 14px;
  font-family: "Gotham", Arial, sans-serif;
  cursor: pointer;
  border: none;
  outline: none;
}
.lower-container button.secondary {
  background-color: white;
  color: #0066b2;
  border: 1px solid #0066b2;
}
.lower-container button.button {
  background-color: #0066b2;
  border: 1px solid #0066b2;
  color: #ffffff;
}
.lower-container button.button:hover {
  background-color: #0b2d71;
}
.lower-container button:disabled {
  background-color: #e0e0e0;
  border: 1px solid #e3e3e3;
  color: #999;
  cursor: default;
}

.mode-selection {
  display: flex;
  gap: 16px;
  margin: 16px 0;
}

.mode-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px 16px;
  border: 2px solid #d0d0d0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  font-family: "Gotham", Arial, sans-serif;
}
.mode-card mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: #0066b2;
}
.mode-card .mode-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #0066b2;
  text-transform: lowercase;
}
.mode-card .mode-card-desc {
  font-size: 12px;
  color: #666;
  text-align: center;
  line-height: 1.4;
}
.mode-card:hover {
  border-color: #0066b2;
  box-shadow: 0 2px 8px rgba(11, 45, 113, 0.15);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
